import React from 'react';
import { PortalContext } from '../../../context/portal-context';
import { VehicleNotificationType } from '../notifications-types';

export function useVehicleNotifications() {
	const { portalService } = React.useContext(PortalContext);

	const vehicles = portalService.getPersonVehicles().getValue();

	return (
		vehicles?.vehicles.flatMap((vehicle) => {
			if (!vehicle) return [];

			const base = { vehicle };

			const notifications = [];

			if (vehicle.alertPreITV) {
				notifications.push({
					...base,
					notificationType: VehicleNotificationType.PreITV,
				});
			}

			if (vehicle.alertNextMaintenance) {
				notifications.push({
					...base,
					notificationType: VehicleNotificationType.Mantenimiento,
				});
			}

			return notifications;
		}) ?? []
	);
}
